import React from "react";
import { Box } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

/**
 * Editor rico simples para textos longos (HTML).
 * - Permite colar direto do Word mantendo formatação básica.
 * - Negrito, itálico, títulos, listas, links, etc.
 */
const toolbarOptions = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["link"],
  ["clean"],
];

const modules = {
  toolbar: toolbarOptions,
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
  "link",
];

export default function RichTextEditor({ value, onChange, height = 320 }) {
  return (
    <Box
      sx={{
        "& .ql-container": {
          borderRadius: 1,
          minHeight: height,
        },
        "& .ql-toolbar": {
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        },
      }}
    >
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        formats={formats}
      />
    </Box>
  );
}
